import { render, staticRenderFns } from "./homepage_pc.vue?vue&type=template&id=9e87c702&scoped=true&"
import script from "./homepage_pc.vue?vue&type=script&lang=js&"
export * from "./homepage_pc.vue?vue&type=script&lang=js&"
import style0 from "./homepage_pc.vue?vue&type=style&index=0&id=9e87c702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e87c702",
  null
  
)

export default component.exports